import type { Directive } from 'vue';
import { useAuthStore } from '@/stores/auth';

export const vPermission: Directive<HTMLElement, string[]> = {
  mounted(el, binding) {
    const auth = useAuthStore();
    const required = binding.value || [];
    if (required.length === 0) return;
    const hasPermission = required.some((p: string) => auth.permissions?.includes(p));
    if (!hasPermission) {
      const comment = document.createComment('no permission');
      el.parentNode?.replaceChild(comment, el);
      (el as any).__permissionComment = comment;
    }
  },
  updated(el, binding) {
    const auth = useAuthStore();
    const required = binding.value || [];
    const hasPermission = required.length === 0 || required.some((p: string) => auth.permissions?.includes(p));
    const comment = (el as any).__permissionComment;
    if (!hasPermission && !comment) {
      const c = document.createComment('no permission');
      el.parentNode?.replaceChild(c, el);
      (el as any).__permissionComment = c;
    } else if (hasPermission && comment) {
      comment.parentNode?.replaceChild(el, comment);
      delete (el as any).__permissionComment;
    }
  },
};

export function registerDirectives(app: import('vue').App) {
  app.directive('permission', vPermission);
}
